<template>
	<div class="dropdown">
		<button
			@click="onClick"
			class="nav dropdown__expand-btn"
			:class="expanded && 'is-open'"
			type="button"
			data-testid="dropdown-list-button"
			ref="button"
		>
			<span class="dropdown__text">{{ selectedText }}</span>
			<i class="icon icon-arrow_down_filled"></i>
		</button>
		<ul class="dropdown__list" v-if="expanded">
			<template v-for="option in options">
				<li
					class="dropdown__list-item"
					:ref="`li${option.value}`"
					:key="option.value"
					:data-value="option.value"
					:class="[
						'dropdown-list__item',
						selected == option.value ? 'is-active' : ''
					]"
					@click="onSelect(option)"
				>
					{{ option.text }}
				</li>
				<li
					class="dropdown__divider"
					:key="option.value"
					v-if="option.hasDivider"
				>
					<hr class="dropdown__divider-line" />
				</li>
			</template>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'DropdownList',
	data() {
		return {
			selected: this.value,
			expanded: false
		};
	},
	mounted() {
		document.addEventListener('click', this.handleDocumentClicked);
	},
	beforeDestroy() {
		document.removeEventListener('click', this.handleDocumentClicked);
	},
	props: {
		options: {
			type: Array,
			required: true
		},
		value: {
			type: String
		}
	},
	methods: {
		onSelect(option) {
			this.selected = option.value;
			this.$emit('input', this.selected);
			this.$emit('change', this.selected);
			this.onClick();
		},
		onClick() {
			this.expanded = !this.expanded;
		},
		handleDocumentClicked(event) {
			const { target } = event;
			const { $el } = this;
			if (!$el.contains(target) && this.expanded) {
				this.expanded = false;
			}
		}
	},
	computed: {
		selectedText() {
			let text;
			let option;

			option = this.options.find(option => option.value == this.selected);
			text = option.text;

			return text;
		}
	}
};
</script>

<style lang="scss" scoped>
.dropdown {
	position: relative;
	font-size: $txt-font-size;

	&__expand-btn {
		position: relative;
		@include clear-btn-styles;
		padding: $padding-sm;
		padding-right: $padding-lg;
		border: $field-border;
		border-right: none;
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		border-top-left-radius: $border-radius;
		border-bottom-left-radius: $border-radius;
		line-height: 16px;

		&.is-open {
			border-bottom-left-radius: 0;
		}

		.icon {
			position: absolute;
			right: 0;
			padding: $padding-sm;
			@include transform-vertical-center;
			font-size: 10px;
		}

		&:focus,
		&:active {
			outline: none;
			border-color: transparent;

			&:after {
				content: '';
				@include transform-full-center;
				width: calc(100% + 1px);
				height: calc(100% + 3px);
				border: $focus-width $focus-style
					var(--nav-brand-1-border-active);
				z-index: $z-level1-1;
			}
		}
	}

	&__text {
		white-space: nowrap;
	}

	&__list {
		position: absolute;
		left: 0;
		margin-top: -1px;
		background: var(--menu-list-bg);
		color: var(--menu-list-fg);
		border: 1px solid var(--menu-list-border);
		border-bottom-left-radius: $border-radius;
		border-bottom-right-radius: $border-radius;

		@include mq($from: sm-l) {
			@include medium-shadow;
		}
	}

	&__list-item {
		padding: $padding-sm $padding-md;
		white-space: nowrap;

		&:hover {
			background: var(--menu-list-bg-hover);
			color: var(--menu-list-fg-hover);
		}

		&.is-active {
			background: var(--menu-list-bg-active);
			color: var(--menu-list-fg-active);
		}
	}

	&__divider {
		display: flex;
		padding: $padding-xs;

		&-line {
			width: 100%;
			margin-block-start: 0;
			margin-block-end: 0;
			border: 0;
			height: 1px;
			background: var(--bg-2);
		}
	}
}
</style>
